<div>

  <div class="row">
    <h5 class="col-12 kt-font-brand text-center">{{timeElapsed()}}</h5>
    <!-- Area -->
    <div class="form-group w-100 col-12">
      <label>Area</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <!-- <img src="../assets/media/icons/png/shift-details/Area.png" alt="Area" height="20" /> -->
            <svg-icon class="svg_icon16x20 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/area.svg"></svg-icon>
          </span>
        </div>
        <input type="text" class="form-control" [value]="timesheetDetails?.area?.area_name" disabled />
      </div>
    </div>
    <!-- Location -->
    <div class="form-group w-100 col-6">
      <label>Location</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <svg-icon class="svg_icon16x20 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
          </span>
        </div>
        <input type="text" class="form-control" [value]="timesheetDetails?.location?.location_name" disabled />
      </div>
    </div>
    <!-- Client -->
    <div class="form-group w-100 col-6">
      <label>Client</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <svg-icon class="svg_icon16x20 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
          </span>
        </div>
        <input type="text" class="form-control" [value]="timesheetDetails.client?.client_name" disabled />
      </div>
    </div>
    <!-- Start Date & Time -->
    <div class="form-group w-100 col-12">
      <label>Start Date & Time</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <svg-icon class="svg_icon16x20" src="assets/media/iq-svg/without_circle/icon_set_5/start_date_&_time.svg"></svg-icon>
          </span>
        </div>
        <input type="text" class="form-control"
          [value]="timesheetDetails?.timesheet_actual_start_date | TimezoneDateTime" disabled />
        <!-- <textarea rows="2" class="form-control"
          disabled>{{timesheetDetails?.timesheet_actual_start_date | TimezoneDateTime}}</textarea> -->
      </div>
    </div>
    <!-- End Date & Time -->
    <!-- <div class="form-group w-100 col-6">
          <label>Total Time</label>
          <div class="input-group" >
              <div class="input-group-prepend">
                  <span class="input-group-text">
                      <img src="../assets/media/icons/png/shift-details/EndDate&Time.png"
                          alt="Client" height="20" />
                  </span>
              </div>
              <textarea rows="2" class="form-control"
                  disabled>{{ timeElapsed() }} Hours</textarea>
          </div>
          <div></div>
      </div> -->
  </div>

  <ng-container>
    <div class="row">
      <!-- Rest Break -->
      <div class="form-group w-100 col-6" (click)="restClickHandler()">
        <label>Rest Break (Paid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <svg-icon class="svg_icon23x20" src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled>{{timesheetDetails.timesheet_total_paid_break_count}} Rest Break&#10;(Total {{timesheetDetails?.timesheet_total_paid_break_time}} Min)</textarea>
        </div>
      </div>
      <!-- Meal Break -->
      <div class="form-group w-100 col-6" (click)="mealBreakHandler()">
        <label>Meal Break(UnPaid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <svg-icon class="svg_icon23x20" src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled> {{timesheetDetails.timesheet_total_unpaid_break_count}} Meal Break&#10;(Total {{timesheetDetails?.timesheet_total_unpaid_break_time}} Min)</textarea>
        </div>
      </div>
    </div>

    <div class="card-deck row me-0">
      <!-- Task -->
      <div class="card col-3 border-0 form-group mb-3">
        <label>Task</label>
        <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer">
          <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
            <span class="panel-badge">{{timesheetDetails?.timesheet_total_actual_task_group_count}}</span>
            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/task.svg"></svg-icon>
          </div>
        </div>
      </div>
      <!-- Form -->
      <div class="card col-3 border-0 form-group mb-3">
        <label>Form</label>
        <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer">
          <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
            <span class="panel-badge">{{timesheetDetails?.timesheet_total_actual_form_count}}</span>
            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/form_icon.svg"></svg-icon>
          </div>
        </div>
      </div>
      <!-- Loop -->
      <!-- <div class="card col-3 border-0 form-group mb-3">
        <label>Loop</label>
        <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer">
          <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
            <span class="panel-badge">{{timesheetDetails?.timesheet_total_actual_loop_count}}</span>
            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/loop_top_icon_(dark_color).svg"></svg-icon>
          </div>
        </div>
      </div> -->
      <!-- Patrol -->
      <div class="card col-3 border-0 form-group mb-3">
        <label>Patrol</label>
        <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer">
          <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
            <span class="panel-badge">{{timesheetDetails?.shift_patrol_count}}</span>
            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/patrolicon.svg"></svg-icon>
          </div>
        </div>
      </div>
      <!-- Reward -->
      <div class="card col-3 border-0 form-group mb-3">
        <label>Reward</label>
        <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer">
          <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
            <span class="panel-badge">{{timesheetDetails?.timesheet_total_actual_point_count}}</span>
            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/reward.svg"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>
